import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from '@piwikpro/user-groups-crate';
import UserGroups from './UserGroups';

const mapStateToProps = state => ({
  data: state.userGroups.list.userGroups,
  userGroup: state.userGroups.details.userGroup,
  filters: state.userGroups.list.filters,
  isLoading: state.userGroups.list.isLoading,
  failed: state.userGroups.list.failed,
  total: state.userGroups.list.total,
});

const mapDispatchToProps = dispatch => ({
  configureUserGroupsFetch: bindActionCreators(actions.configureUserGroupsFetch, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserGroups);
